module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/press/linescape-ci-award-finalist/linescape-ci-award-finalist.component.scss
// module id = 817
// module chunks = 0